import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function RequireAuth() {
  const { user } = useAuth();
  return user ? <Outlet /> : <Navigate to="/login" replace />;
}

export function RequireAdmin() {
  const { user, isAdmin } = useAuth();
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}

export function RequireGuest() {
  const { user, isAdmin } = useAuth();
  if (!user) return <Outlet />;
  return <Navigate to={isAdmin ? "/admin" : "/dashboard"} replace />;
}

export function RequireAdminGuest() {
  const { user, isAdmin } = useAuth();
  if (!user) return <Outlet />;
  return <Navigate to={isAdmin ? "/admin" : "/dashboard"} replace />;
}
